import { Text } from "../typography";
import { colors } from "../../assets/styles/parameters";
import styled from "styled-components";

export const CheckboxInput = (props) => {
  const { input, meta, label, ...otherProps } = props;
  return (
    <BaseLabel>
      <Text>{label}</Text>
      <input {...input} {...otherProps} type="checkbox" />
      <span />
      {meta.error && meta.touched && <Text>{meta.error}</Text>}
    </BaseLabel>
  );
};
const BaseLabel = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  margin: 1rem 0;
  cursor: pointer;
  user-select: none;
  width: max-content;

  p {
    margin: 0.1rem 0 0 1.8rem;
    padding: 0;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    position: absolute;
    top: 6px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: ${colors.gray200};
    border-radius: 2px;

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 8px;
      top: 4px;
      width: 5px;
      height: 10px;
      border: solid ${colors.white};
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  &:hover input ~ span {
    background-color: ${colors.blue};
  }

  input:checked ~ span {
    background-color: ${colors.blue};
  }

  input:checked ~ span:after {
    display: block;
  }
`;
